export const sanitizeOptions = {
  allowedTags: [
    'html',
    'head',
    'body',
    'meta',
    'title',
    'style',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'blockquote',
    'p',
    'span',
    'a',
    'ul',
    'ol',
    'nl',
    'li',
    'b',
    'i',
    'strong',
    'em',
    'strike',
    'code',
    'hr',
    'br',
    'div',
    'table',
    'thead',
    'caption',
    'tbody',
    'tr',
    'th',
    'td',
    'pre',
    'img',
    'figure',
    'figcaption',
  ],
  allowedAttributes: {
    a: ['href', 'name', 'target', 'rel', 'class', 'style'],
    img: ['src', 'alt', 'class', 'style', 'width', 'height', 'title'],
    meta: ['http-equiv', 'content', 'name'],
    table: ['cellspacing', 'cellpadding', 'class', 'style'],
    td: ['style', 'width', 'colspan', 'rowspan', 'class'],
    tr: ['style', 'class'],
    th: ['style', 'width', 'colspan', 'rowspan', 'class'],
    ul: ['type', 'style', 'class'],
    ol: ['type', 'style', 'class'],
    li: ['class', 'style'],
    '*': ['class', 'style'],
  },
  allowedClasses: {
    figure: [
      'image',
      'image-style-align-left',
      'image-style-align-right',
      'image-style-align-center',
      'table',
    ],
    img: ['image-style-align-left', 'image-style-align-right', 'image-style-align-center'],
    '*': ['*'],
  },
  allowedSchemes: ['http', 'https', 'mailto', 'tel'],
  parseStyleAttributes: false,
  allowVulnerableTags: true,
};
